// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  IntegrationSummary,
  type IntegrationSummaryWireFormat,
  NewIntegrationSummary,
} from '../IntegrationSummary/IntegrationSummary';

export class QuoteExternalID {
  readonly integrationId: string;
  readonly integration: IntegrationSummary;
  readonly externalID: string;
  readonly isExported: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.integrationId = data.integrationId === undefined ? NIL_UUID : data.integrationId;
    this.integration = NewIntegrationSummary(data.integration);
    this.externalID = data.externalID === undefined ? '' : data.externalID;
    this.isExported = data.isExported === undefined ? false : data.isExported;
  }

  static zero(): QuoteExternalID {
    const zeroValues: ExcludeMethodsDeep<QuoteExternalID> = {
      integrationId: NIL_UUID,
      integration: IntegrationSummary.zero(),
      externalID: '',
      isExported: false,
    };
    return new QuoteExternalID(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteExternalIDWireFormat = {
  integrationId: string;
  integration: IntegrationSummaryWireFormat;
  externalID: string;
  isExported: boolean;
};

type NewQuoteExternalIDProps = PartialDeep<QuoteExternalID, { recurseIntoArrays: true }>;
export const NewQuoteExternalID: (props: NewQuoteExternalIDProps) => QuoteExternalID = (props) =>
  new QuoteExternalID(props);

type NewQuoteExternalIDFromWireFormatProps = PartialDeep<
  QuoteExternalIDWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteExternalIDFromWireFormat: (
  props: NewQuoteExternalIDFromWireFormatProps,
) => QuoteExternalID = (props) => new QuoteExternalID(props);
